import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { cadastrarRamo, atualizarRamo } from '~/Services/Service';

const validationSchema = Yup.object().shape({
  descricao: Yup.string()
    .trim()
    .required('Descrição é obrigatória')
    .max(30, 'Descrição deve ter no máximo 30 caracteres'),
  obra: Yup.string()
    .oneOf(['', 'S', 'N'], 'Valor inválido para Obra')
    .nullable(),
});

const ModalRamo = ({ show, onHide, ramo, onSalvar }) => {
  const ehEdicao = ramo != null;

  const initialValues = ehEdicao
    ? { codigo: ramo.codigo, descricao: ramo.descricao || '', obra: ramo.obra || '' }
    : { descricao: '', obra: '' };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        descricao: values.descricao,
        obra: values.obra === '' ? null : values.obra,
      };

      if (ehEdicao) {
        await atualizarRamo({ codigo: values.codigo, descricao: payload.descricao, obra: payload.obra });
        toast.success('Ramo atualizado com sucesso');
      } else {
        await cadastrarRamo(payload);
        toast.success('Ramo cadastrado com sucesso');
      }

      onSalvar();
      onHide();
    } catch (err) {
      toast.error(err && err.message ? err.message : 'Erro ao salvar');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
      >
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {ehEdicao ? 'Editar Ramo' : 'Novo Ramo'}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form onSubmit={formik.handleSubmit}>
              <Modal.Body>
                {ehEdicao && (
                  <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm={4} className="text-right font-weight-bold">
                      Código
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={formik.values.codigo}
                        readOnly
                        disabled
                        style={{ backgroundColor: '#f5f5f5' }}
                      />
                    </Col>
                  </Form.Group>
                )}

                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm={4} className="text-right font-weight-bold">
                    Descrição <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm={8}>
                    <Field
                      as={Form.Control}
                      type="text"
                      name="descricao"
                      maxLength={30}
                      isInvalid={formik.touched.descricao && !!formik.errors.descricao}
                    />
                    <ErrorMessage
                      name="descricao"
                      component="div"
                      className="invalid-feedback d-block"
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm={4} className="text-right font-weight-bold">
                    Aparece no diário de obras
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      as="select"
                      name="obra"
                      value={formik.values.obra}
                      onChange={formik.handleChange}
                      isInvalid={formik.touched.obra && !!formik.errors.obra}
                    >
                      <option value="">Selecione</option>
                      <option value="N">Não</option>
                      <option value="S">Sim</option>
                    </Form.Control>
                    <ErrorMessage
                      name="obra"
                      component="div"
                      className="invalid-feedback d-block"
                    />
                  </Col>
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={formik.isSubmitting}>
                  Cancelar
                </Button>
                <Button variant="primary" type="submit" disabled={formik.isSubmitting}>
                  {formik.isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ModalRamo;
